import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from '../../../store/actions'
import Details from './Details'

const mapStateToProps = state => ({
  events: state.events,
  topics: state.topics,
  library: state.library,
  user: state.user,
  organizations: state.organizations.list
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      upload: actions.library.upload,
      clearUploadList: actions.library.clearUploadList,
      updateUser: actions.user.updateUser,
      updateTopicList: actions.topics.updateTopicList
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Details)
